<div class="dashboard-header">
    <h4>Welcome back</h4>
    <div class="user-controls">
        <h1 class="flex-1">{{ userName }}</h1>
        <ng-container *ngIf="isSupervisorDashboardEnabled && teams && teams.length > 0">
            <mat-form-field>
                <mat-label>Team View</mat-label>
                <mat-select [value]="teamId" (selectionChange)="onTeamChange($event.value)">
                    <mat-option *ngIf="clientId" value="my-dashboard">My Dashboard</mat-option>
                    <mat-option *ngFor="let team of teams" [value]="team.id">
                        {{ team.name }} Team
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *ngIf="isAccountFilterEnabled && accounts && accounts.length > 0 && teamId !== 'my-dashboard'">
            <mat-form-field>
                <mat-label>Filter By Account</mat-label>
                <mat-select multiple [ngModel]="accountFilterModel" (ngModelChange)="onAccountChange($event)">
                    <mat-select-trigger>{{ accountFilterLabel }}</mat-select-trigger>
                    <mat-option value="all-accounts">All Accounts</mat-option>
                    <mat-option *ngFor="let account of accounts" [value]="account.parentAccountId">
                        {{ account.name }} ({{ account.code }})
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
    </div>
</div>